export const MAX_FAULT_ICONS_ON_PANELS_PAGE = 100